import * as React from "react";
import Box from "@mui/material/Box";
import ViewResourceFolderStructure from "./ViewResourceFolderStructure";
import { useParams } from "react-router-dom";
import { useGetClientAccPDByIdQuery, useGetFolderStructureForPDsByClientAccIdQuery } from "../../../../reactQueries/AppApi/rqHooksForClientAccProgrammeDescriptor";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import {useOutletContext } from "react-router-dom";

const ResourceFolderStructureHome = () => {

  let { id } = useParams();
  const {
    data: dataById,
    isError: isErrorOnClientAccPDById,
    isFetching: isFetchingOnClientAccPDById,
    isSuccess: isSuccessOnClientAccPDById,
    error: errorOnClientAccPDById,
  } = useGetClientAccPDByIdQuery({ clientAccountId: id });

  // console.log("vvv111111:", dataById)
  const resourcesCMSData = useOutletContext();

  const fetchCommonCMSLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
        const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
        return returnLabel(commonCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  return (
    <div>
      {
        !!isFetchingOnClientAccPDById && fetchCommonCMSLabel('Common.Fetching') //"Wait, Loading...."
      }
      {!!isSuccessOnClientAccPDById && (
        <ViewResourceFolderStructure clientAccPDDetailsById={dataById} />
      )}

      <MpgErrorDialog
        open={!!isErrorOnClientAccPDById}
      />
    </div>
  );
};

export default ResourceFolderStructureHome;